/** @jsx jsx */
import { jsx } from '@emotion/react';
import React, { useContext } from 'react';
import { Tab, Tabs } from '@blueprintjs/core';
import { filterProperties } from 'utilities/srsUtils';
import { WorkspaceContext } from 'views/workspace/workspaceContext';
import CustomMultiSelect from 'components/custom-multiselect/custom-multiselect';
import { WorkspaceActionCreator } from 'hooks/useWorkspaceState';

/**
 * Custom renderer for the controls available to change the chart settings.
 *
 * Data Properties for this Widget:
 *   -- propertyList
 *   -- limit
 *
 * Chart Properties for this Widget:
 *
 * @param chartConfiguration
 * @param updateConfiguration
 * @param propertyList
 * @returns {*}
 * @constructor
 */
export const ParaCordKnobs = ({ cardIndex, endpointQuery, flags, types }) => {
	const {
		state: {
			explorer: { selectedDefinitionName },
		},
		dispatch
	} = useContext(WorkspaceContext);
	const propertyName = 'propertyList';

	const items = filterProperties(selectedDefinitionName, flags, types).map(property => property.name);

	const handleSortingOfColumns = ({selected: sortedSelected/*, unselected: sortedUnselected */}) => {
		const selected = sortedSelected;
		const newColumns = selected.filter(selection =>
			items.includes(selection)
		);

		// create copy of options object
		const newEndpointQuery = JSON.parse(JSON.stringify(endpointQuery));
		newEndpointQuery.options[propertyName] = newColumns;
		dispatch(WorkspaceActionCreator.options(cardIndex, newEndpointQuery));
	};

	const initialSelected = endpointQuery?.options?.[propertyName];
  return (
  	<Tabs>
			<Tab id="data" title="Data" panel={
				<CustomMultiSelect items={items} initialSelected={initialSelected}
													 onSubmit={handleSortingOfColumns} minimumItems={2}/>
			}/>
		</Tabs>
  );
};
